import React, { useState } from 'react';
import { Descriptions } from 'antd';
import { Modal } from 'antd';
import styled from 'styled-components';

import { DARK_MODAL_CLASS } from 'components/theme/DarkPageScope/constants';
import API from 'utils/request';

import { getCardType } from '../filters/filterOptions';
import { ICustomerCard } from './BDOCustomerCard';

interface ICardModalProps {
  open: boolean;
  cardProps: ICustomerCard['cardProps'];
  closeModal: () => void;
  onCancel: () => void;
  refetchCustomer: () => void;
}
const COLOR = '#4AB682';

const ActivateCardModal = ({
  open,
  cardProps,
  closeModal,
  onCancel,
  refetchCustomer
}: ICardModalProps) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  return (
    <StyledModal
      wrapClassName={DARK_MODAL_CLASS}
      open={open}
      title="Activate card?"
      bodyStyle={{ padding: '30px 38px' }}
      okButtonProps={{
        style: { backgroundColor: COLOR, border: 'transparent', fontWeight: '600' }
      }}
      okText="Activate card"
      confirmLoading={confirmLoading}
      onOk={async () => {
        setConfirmLoading(true);
        try {
          await API.patch(
            `/v4/dash/custom/bdo/card_status/${cardProps.brc}`,
            {
              card: {
                'Card Status': 'A',
                'Activity Description': 'Activated',
                Remarks: 'Activated'
              }
            },
            { headers: { 'Content-Type': 'application/json' } }
          );
          setConfirmLoading(false);
          closeModal();
          Modal.success({
            title: 'Card successfully activated',
            content: (
              <div>
                <p>BRC {cardProps.brc} has been successfully activated.</p>
              </div>
            ),
            onOk() {
              refetchCustomer();
            }
          });
        } catch (e) {
          const errorMsg = e?.response?.data?.message;
          setConfirmLoading(false);
          closeModal();
          Modal.error({
            title: 'Card activation failed',
            content: <div>{errorMsg && <p>{errorMsg}</p>}</div>
          });
        }
      }}
      onCancel={onCancel}
    >
      <Descriptions column={{ sm: 1 }} colon={false} layout="horizontal" title="">
        <Descriptions.Item key="brc" label="BRC">
          <strong>{cardProps?.brc}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="tier" label="Tier">
          <strong>{getCardType(cardProps?.tier)?.label}</strong>
        </Descriptions.Item>
        <Descriptions.Item key="seq" label="Seq">
          <strong>{cardProps?.sequence}</strong>
        </Descriptions.Item>
      </Descriptions>
      Are you sure you want to activate this card?
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-header {
    background-color: ${COLOR};
    color: white;
  }

  .ant-modal-title {
    color: white;
    font-weight: 600;
  }

  .ant-modal-close-x {
    color: white;
  }
`;

export default ActivateCardModal;
